import { ApiDocPluginFactory } from './plugin'
export default ApiDocPluginFactory
